<template>
  <div class="form-group">
    <label class="form-label"><strong>{{ headline }}</strong></label>
    <div class="row gutters-xs m-0">
      <div class="col-auto" style="padding: 1px" v-for="emoji in emoji_list" :key="emoji">
        <label class="colorinput">
          <input
            name="emoji"
            type="checkbox"
            class="colorinput-input colorinput-input--emoji"
            :value="emoji"
            :checked="emoji === selected_emoji"
            @input="select_emoji($event, emoji)">
          <span :class="[size, 'colorinput-emoji']">{{emoji}}</span>
        </label>
      </div>

      <div class="col-auto" style="padding: 1px" v-if="showUnsetOption">
        <label class="custom-control custom-checkbox pl-0">
          <input
            type="checkbox"
            class="custom-control-input"
            name="emoji_default"
            :checked="'default' === selected_emoji"
            @input="select_emoji($event, 'default')" />
          <span :class="[size, 'custom-control-label']">Remove</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
// const EMOJI_LIST_BUGS = ['🐛', '🐜', '🦗', '🐞', '🕷️', '🦋', '🦟']
const EMOJI_LIST_BUGS = ['🐛', '🐞', '🐜', '🕷️', '🦋']

/*
:bug: 🐛
:ant: 🐜
// :cricket: 🦗
:beetle: 🐞
// :butterfly: 🦋
// :mosquito: 🦟
// :spider: 🕷️
// :raccoon: 🦝
:rat: 🐀
:snake: 🐍
:sauropod: 🦕
:dragon_face: 🐲
:dragon: 🐉
*/

export default {
  props: {
    selected_emoji: { // TODO: value
      type: String,
      default: null
    },
    headline: {
      type: String,
      default: "Select an emoji"
    },
    size: {
      default: 'normal'
    },
    showUnsetOption: {
      default: false
    }
  },
  data() {
    return {
      emoji_list: EMOJI_LIST_BUGS
    };
  },
  methods: {
    select_emoji(evt, emoji) {
      if ( evt.target.checked ) {
        console.log("Emitting emoji " + emoji);
        this.$emit("emoji-select", emoji);
      } else {
        this.$emit("emoji-select", null);
      }
    }
  }
};
</script>

<style>
.colorinput-input--emoji:checked + .colorinput-emoji {
  border: 1px solid #AAA;
  padding: 0 2px;
  border-radius: 3px;
}
.colorinput-emoji.small {
  font-size: 1.5em;
}
.colorinput-emoji.mini {
  font-size: 1em;
}
</style>
